import * as React from 'react'
import { SxProps, Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { Branch } from '@user/store/branches/typings'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

const getStyles = (theme: Theme) => ({
  details: {
    backgroundColor: '#f3f3f3',
    padding: `${theme.spacing(1.4)} ${theme.spacing(2)}`,
    marginTop: theme.spacing(0.8),
  },

  noSelection: {
    color: '#9c9c9c',
  },

  table: {
    tableLayout: 'fixed',
  },

  prop: {
    fontFamily: 'Source Sans Pro Semibold',
    width: '175px',
    padding: theme.spacing(0),
    borderBottom: 'none',
  },

  propCell: {
    padding: theme.spacing(0),
    borderBottom: 'none',
  },
})

interface Props {
  branch?: Branch
  sx?: SxProps<Theme>
}

export const BranchDetails: FC<Props> = (props) => {
  const { branch, sx = {} } = props

  const { t } = useTranslation()
  const styles = getStyles(useTheme())
  const classname = branch
    ? { ...styles.details }
    : { ...styles.details, ...styles.noSelection }

  return (
    <Box sx={{ ...classname, ...sx }}>
      <Table sx={{ ...styles.table }}>
        <TableBody>
          <TableRow>
            <TableCell sx={{ ...styles.prop }}>Branch Name</TableCell>
            {branch && (
              <TableCell sx={{ ...styles.propCell }}>{branch.name}</TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>Address</TableCell>
            {branch && branch.address && (
              <TableCell sx={{ ...styles.propCell }}>
                {branch.address.address}
              </TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>City</TableCell>
            {branch && branch.address && (
              <TableCell sx={{ ...styles.propCell }}>
                {branch.address.city}
              </TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>{t('state')}</TableCell>
            {branch && branch.address && (
              <TableCell sx={{ ...styles.propCell }}>
                {branch.address.state}
              </TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>{t('postalCode')}</TableCell>
            {branch && branch.address && (
              <TableCell sx={{ ...styles.propCell }}>
                {branch.address.postalCode}
              </TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>Phone</TableCell>
            {branch && (
              <TableCell sx={{ ...styles.propCell }}>{branch.phone}</TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>Email</TableCell>
            {branch && (
              <TableCell sx={{ ...styles.propCell }}>{branch.email}</TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell sx={{ ...styles.prop }}>Time Zone</TableCell>
            {branch && <TableCell sx={{ ...styles.propCell }}>N/A</TableCell>}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}
BranchDetails.displayName = 'BranchDetails'
